import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import authenticateConfig from '../config/authenticate.js'

Vue.use(VueAxios, axios)
const vueAuthInstance = VueAuthenticate.factory(Vue.axios, authenticateConfig)

export default vueAuthInstance


// WEBPACK FOOTER //
// ./src/services/authenticationService.js